<section class="grid-col-12 grid-max-width no-row-gap">
  <div
    class="col-1-12 md-col-1-6 mr-clear pr-xsmall-t"
    *ngIf="destinationTeaserText"
    [innerHTML]="destinationTeaserText | resolveLinks | finSafe: 'html'"
  ></div>
</section>
